import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appendAdsTxtRequest = {};
var _appendAdsTxtResponse = {};
var _getAdsTxtRequest = {};
var _getAdsTxtResponse = {};
var _updateAdsTxtRequest = {};
var _updateAdsTxtResponse = {};
function resolveComWixpressPromoteSeoRobotsServerV2AdsServiceV2Url(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/promote-seo-robots-server',
                destPath: '/api',
            },
            {
                srcPath: '/_api/promote-seo-robots-server/v2/robots',
                destPath: '/v2/robots',
            },
            {
                srcPath: '/_api/promote-seo-robots-server/v2/ads',
                destPath: '/v2/ads',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/promote-seo-robots-server',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/promote-seo-robots-server',
                destPath: '/api',
            },
            {
                srcPath: '/_api/promote-seo-robots-server/v2/robots',
                destPath: '/v2/robots',
            },
            {
                srcPath: '/_api/promote-seo-robots-server/v2/ads',
                destPath: '/v2/ads',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/promote-seo-robots-server/v2/robots',
                destPath: '/v2/robots',
            },
            {
                srcPath: '/promote-seo-robots-server/v2/ads',
                destPath: '/v2/ads',
            },
            {
                srcPath: '/promote-seo-txt-file-server/v2/ads',
                destPath: '/v2/ads',
            },
            {
                srcPath: '/promote-seo-txt-file-server/v2/robots',
                destPath: '/v2/robots',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves the Ads.txt file. */
export function getAdsTxt(payload) {
    var _a = serializer(_getAdsTxtRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAdsTxtResponse, {}).fromJSON;
    function __getAdsTxt(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.promote.marketing.v2.ads_txt',
            method: 'GET',
            methodFqn: 'com.wixpress.promote.seo.robots.server.v2.AdsServiceV2.GetAdsTxt',
            url: resolveComWixpressPromoteSeoRobotsServerV2AdsServiceV2Url({
                protoPath: '/v2/ads',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAdsTxt.fromReq = fromReq;
    __getAdsTxt.__isAmbassador = true;
    return __getAdsTxt;
}
/**
 * Updates the Ads.txt file.
 * When setting the `content` object to an empty string, an empty Ads.txt file will be created.
 * In order to reset Ads.txt to Wix's default, send `default: true` without a `content` object.
 */
export function updateAdsTxt(payload) {
    var _a = serializer(_updateAdsTxtRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateAdsTxtResponse, {}).fromJSON;
    function __updateAdsTxt(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.promote.marketing.v2.ads_txt',
            method: 'PUT',
            methodFqn: 'com.wixpress.promote.seo.robots.server.v2.AdsServiceV2.UpdateAdsTxt',
            url: resolveComWixpressPromoteSeoRobotsServerV2AdsServiceV2Url({
                protoPath: '/v2/ads',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateAdsTxt.fromReq = fromReq;
    __updateAdsTxt.__isAmbassador = true;
    return __updateAdsTxt;
}
/**
 * Appends the submitted `content` object to Ads.txt.
 * In order to reset Ads.txt to Wix's default, send `default: true` without a `content` object.
 */
export function appendAdsTxt(payload) {
    var _a = serializer(_appendAdsTxtRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_appendAdsTxtResponse, {}).fromJSON;
    function __appendAdsTxt(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.promote.marketing.v2.ads_txt',
            method: 'PATCH',
            methodFqn: 'com.wixpress.promote.seo.robots.server.v2.AdsServiceV2.AppendAdsTxt',
            url: resolveComWixpressPromoteSeoRobotsServerV2AdsServiceV2Url({
                protoPath: '/v2/ads',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __appendAdsTxt.fromReq = fromReq;
    __appendAdsTxt.__isAmbassador = true;
    return __appendAdsTxt;
}
//# sourceMappingURL=http.impl.js.map